<template>
  <div>
    <el-dialog v-model="dialogVisible" :title="title" :close-on-click-modal="false" width="1300px" center>
      <div class="red" v-html="info"></div>
      <div class="red" v-html="ruleName"></div>
      <el-table v-loading="loading" :data="tableData" :max-height="maxH" empty-text="暂无数据" style="width: 100%">
        <el-table-column prop="car_number" label="车牌号" width="130"> </el-table-column>
        <el-table-column prop="ent_gate_name" label="入场通道"> </el-table-column>
        <el-table-column prop="ent_time" label="入场时间"> </el-table-column>
        <el-table-column prop="dep_gate_name" label="出场通道"> </el-table-column>
        <el-table-column prop="dep_time" label="出场时间"> </el-table-column>
        <el-table-column prop="memo" label="备注"> </el-table-column>
        <el-table-column prop="ent_pic" label="入场抓拍照片" width="120">
          <template #default="scope">
            <label class="preview-img" @click="previewImg(scope.row.ent_pic)">查看图片</label>
            <!-- <el-image :src="scope.row.ent_pic" :preview-src-list="[scope.row.ent_pic]" /> -->
          </template>
        </el-table-column>
        <el-table-column prop="dep_pic" label="出场抓拍照片" width="120">
          <template #default="scope">
            <label class="preview-img" @click="previewImg(scope.row.dep_pic)">查看图片</label>
            <!-- <el-image :src="scope.row.dep_pic" :preview-src-list="[scope.row.dep_pic]" /> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :hide-on-single-page="false" layout="prev, pager, next" :page-size="searchForm.per_page"
        :total="total" @current-change="currentChange">
      </el-pagination>
    </el-dialog>
    <PreviewImg ref="PreviewImg" />

  </div>
</template>

<script>
import * as API_index from "@/api/index";
import PreviewImg from '@/components/PreviewImg'

export default {
  name: '',
  components: {
    PreviewImg
  },
  props: {
    title: {
      type: [String, Number],
      default: ''
    },
    close: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      searchForm: {
        park_id: this.getStore('park_id'),
        record_id: undefined,
        page: 1,
        per_page: 10,
      },
      ruleName: '',
      info: '',
      total: 0,
      tableData: [],
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    init(record_id) {

      this.dialogVisible = true
      if (record_id) {
        this.searchForm.record_id = record_id
      }
      this.getData()
    },
    currentChange(e) {
      this.searchForm.page = e
      this.getData()
    },
    getData() {
      this.loading = true
      API_index.getBillingDep(this.searchForm).then(res => {
        this.loading = false
        this.info = res.info
        this.ruleName = res.rule_name
        this.tableData = res.relations
        this.total = res.relations?.length
      })

    },

    previewImg(url) {
      this.$refs.PreviewImg.init(url)
    },
  },
}
</script>
<style lang="scss" scoped>
.preview-img {
  color: $primary;
  cursor: pointer;
}
</style>